// element-ui处理

import Vue from 'vue'
import ElementUI from 'element-ui';
import {lang} from "../utils/filters"


  // elementui 引入使用 国际化
  import i18n from '@/i18n/index'
  export default i18n;
  Vue.prototype.$lang = lang;
  Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value), // 国际化
  })